import React, { useState } from "react";
import Time from "react-time-format";
import { ProductConsumer } from "../../../Context/AddProWakel";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import Instance from "../../../util/Instance";
import setToken from "../../../util/setToken";

const FillDetailKogaRaport = () => {
  // GET /api/v1/Restart recalculates rasidKarton for EVERY product from the
  // sale/return history, so it can run for minutes on a big catalogue. Give this
  // one request its own long timeout (the shared Instance defaults to 30s) and
  // keep the button disabled while it runs so it can't be fired twice.
  const [restarting, setRestarting] = useState(false);

  const restartKoga = async (reloadReport) => {
    if (restarting) return;
    const confirmed = await swal({
      title: "ڕیستارتکردنی کۆگا",
      text: "ڕەسیدی هەموو کاڵاکان لە سەرەتاوە دەژمێردرێتەوە و کاتی دەوێت. دڵنیایت؟",
      icon: "warning",
      buttons: ["نەخێر", "بەڵێ"],
      dangerMode: true
    });
    if (!confirmed) return;

    setRestarting(true);
    try {
      if (localStorage.token) {
        setToken(localStorage.token);
      }
      const res = await Instance.get("/api/v1/Restart", { timeout: 900000 });
      if (res.data && res.data.status) {
        swal({
          title: "تەواو بوو",
          text: "ڕەسیدی کۆگا نوێکرایەوە",
          icon: "success"
        });
        // Pull the recalculated numbers back into the report on screen.
        if (typeof reloadReport === "function") {
          reloadReport();
        }
      } else {
        swal({
          title: "ببورە",
          text: "ڕیستارتکردنی کۆگا سەرکەوتوو نەبوو",
          icon: "error"
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: !window.navigator.onLine
          ? "هێڵی ئنتەرنێتەکەت کێشەی هەیە"
          : "ڕیستارتکردنی کۆگا سەرکەوتوو نەبوو",
        icon: "error"
      });
    } finally {
      setRestarting(false);
    }
  };

  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            AddProChange,
            JM_name,
            JM_code,
            JM_yaksanbasfrfn,
            JM_zyatrlasfrfn,
            JM_barwar,
            JM_pshandan,
            RKP_getPrint
          } = value;
          return (
            <>
              <div className="row" style={{ backgroundColor: "#2C3539" }}>
                <div className="col-lg-3 col-5 form-inline">
                  <div className="row form-inline">
                    <div className="col-7 form-inline">
                      <p className="font-weight-bold bg-white text-black f4">
                        <Time format="YYYY-MM-DD" />
                      </p>
                      <span style={{ color: "#2C3539" }}>:</span>
                      <p className="font-weight-bold bg-white text-black f4">
                        {JM_barwar}
                      </p>
                    </div>
                    <div className='col-5 form-inline"'>
                      <label className="text-warning font-weight-bold f4">
                        : بەرواری{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 col-7  mt3">
                  <div className="row">
                    <div className="col-6">
                      <input
                        type="text"
                        name="JM_name"
                        value={JM_name}
                        onChange={AddProChange}
                        aria-label="Large"
                        className="form-control"
                      />
                    </div>
                    <div className="col-3">
                      <input
                        type="text"
                        name="JM_code"
                        value={JM_code}
                        onChange={AddProChange}
                        aria-label="Large"
                        className="form-control"
                      />
                    </div>
                    <div className="col-3">
                      <label className="text-warning f4 font-weight-bold">
                        گەڕان
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-6 mt3">
                  <div className="row">
                    <div className="col-lg-3 col-3">
                      <Link to="/print-Koga">
                        <button
                          className="btn  btn-secondary ml3"
                          onClick={RKP_getPrint}
                        >
                          چاپکردن
                        </button>
                      </Link>
                    </div>
                    <div className="col-lg-3 col-3 ">
                      <button
                        className="btn  btn-success "
                        onClick={JM_zyatrlasfrfn}
                      >
                        ماوە
                      </button>
                    </div>
                    <div className="col-lg-3 col-3">
                      <button
                        className="btn  btn-warning"
                        onClick={JM_yaksanbasfrfn}
                      >
                        نەماوە
                      </button>
                    </div>
                    <div className="col-lg-3 col-3">
                      <button
                        className="btn  btn-info ml3"
                        onClick={JM_pshandan}
                      >
                        هەر هەمویان
                      </button>
                    </div>
                  </div>
                  {/* Own row so the four buttons above keep their layout. */}
                  <div className="row mt-2 mb-2">
                    <div className="col-12">
                      <button
                        className="btn btn-danger"
                        onClick={() => restartKoga(JM_pshandan)}
                        disabled={restarting}
                      >
                        {restarting
                          ? "چاوەڕوان بە ..."
                          : "ڕیستارتکردنی کۆگا"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FillDetailKogaRaport;
